/**
 * Combine data from Y4 API response into option for ECharts
 */

//import { getColor, rgbaColor } from 'helpers/utils';

const EChartsBasicChart = ({ option, data }) => {
  option.option.xAxis.data = data.axisXData;
  if (data.series.length == 1) {
    option.option.series[0].data = data.series[0].data[0];
  } else {
    const serie_templete = option.option.series[0];
    option.option.series = data.series.map(s => {
      const newSerie = { ...serie_templete };
      newSerie.name = s.name;
      newSerie.data = s.data[0];
      return newSerie;
    });
  }
  console.log(option);
};

export default { EChartsBasicChart };
